import { isTablet } from "../utils/breakpoints";
const animateFirstSection = (element) => {
    const observer = new IntersectionObserver(([entry], obs) => {
        if (entry.isIntersecting) {
            element.classList.add('is-visible');
            obs.unobserve(element);
        }
    }, {
        threshold: isTablet ? 0.1 : 0.2,
        rootMargin: isTablet ? "-100px" : "0px"
    });
    observer.observe(element);
};
const registerFirstSectionAnimations = () => {
    const sectionelements = document.querySelectorAll('[data-anim="first-section"]');
    sectionelements.forEach(el => animateFirstSection(el));
};
export default registerFirstSectionAnimations;
